import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from "../../../ui/AlertDialog/AlertDialog";
import { t } from "i18next";
import React, { useEffect } from "react";
import { useFetch } from "../../../hooks/useFetch";
import { Button } from "../../../ui/Button";
import { useAppStore } from "../../../stores/RootStore";
import { useNavigate } from "react-router-dom";

type Props = {
  id: string;
  isDeleteOpen: boolean;
  closeModal: Function;
};

const DeleteProducer = ({ id, isDeleteOpen, closeModal }: Props) => {
  const [{ response: itemDeleteResponse, isLoading: itemDeleteIsLoading, error: itemDeleteError }, doFetchItemDelete] =
    useFetch(`/directories/producers/${id}`);

  const setProducers = useAppStore((store) => store.setProducers);
  const producers = useAppStore((store) => store.producers);

  const deleteItem = () => {
    setProducers(producers?.filter((producer) => producer.id != id)!);
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (itemDeleteResponse) {
      deleteItem();
      navigate("..", { relative: "path" });
      closeModal();
    }
  }, [itemDeleteResponse]);

  const onDelete = () => {
    doFetchItemDelete({
      method: "DELETE",
    });
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }}>
        <AlertDialogTitle>Удалить производителя</AlertDialogTitle>
        <AlertDialogDescription>Вы уверены, что хотите удалить производителя?</AlertDialogDescription>
        <div className="flex justify-between mt-4">
          <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>
            {t("delete")}
          </Button>
          <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteProducer;
